import { cloneElement, isValidElement } from 'react'

import PropTypes from 'prop-types'

import createLogger from '~/src/Lib/Logging'
import { EMPTY_OBJECT, noop } from '~/src/Lib/Utils'

import { useAllowed } from './utils'

const logger = createLogger('Flags/Allowed')

export const Allowed = ({
  actions,
  anyAction,
  anyFeature,
  apps,
  features,
  negate,
  setting,
  settingTest,
  facilityTypes,
  children = null,
  Fallback: OriginalFallback = noop,
  FallbackProps = EMPTY_OBJECT,
  PermissionFallback = OriginalFallback,
  ...passthru
}) => {
  const allowedResult = useAllowed({
    actions,
    anyAction,
    anyFeature,
    apps,
    features,
    negate,
    setting,
    settingTest,
    facilityTypes,
  })
  if (!Array.isArray(allowedResult)) {
    console.error('allowedResult is not an array', { allowedResult, ...passthru })
    return <OriginalFallback {...FallbackProps} />
  }
  const [isAllowed, failedPermissions] = allowedResult
  logger.debug('Allowed:', { isAllowed, failedPermissions, passthru })
  if (isAllowed) {
    return isValidElement(children) ? cloneElement(children, passthru) : children
  }
  const Fallback = failedPermissions ? PermissionFallback : OriginalFallback

  return isValidElement(Fallback) ? Fallback : <Fallback {...FallbackProps} />
}
const flagType = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.string,
  PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.string])),
])
const appType = PropTypes.oneOf(['AROYA'])

Allowed.propTypes = {
  actions: flagType,
  anyAction: PropTypes.bool,
  anyFeature: PropTypes.bool,
  features: flagType,
  apps: PropTypes.oneOfType([appType, PropTypes.arrayOf(appType)]),
  facilityTypes: flagType,
  children: PropTypes.node,
  Fallback: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element]),
  FallbackProps: PropTypes.object,
  PermissionFallback: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element]),
}
